import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCirclePlaceholderOff: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconCirclePlaceholderOff"><Path d="M7.93227 3.69009C9.15988 3.08804 10.5405 2.75 12 2.75C17.1086 2.75 21.25 6.89137 21.25 12C21.25 13.4595 20.912 14.8401 20.3099 16.0677M3.5 3.5L20.5 20.5M12 21.25C6.89137 21.25 2.75 17.1086 2.75 12C2.75 9.44568 3.78534 7.13318 5.45926 5.45926L18.5407 18.5407C16.8668 20.2147 14.5543 21.25 12 21.25Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconCirclePlaceholderOff;
